import {
  HttpLink,
  ApolloClient,
  ApolloLink,
  InMemoryCache,
} from "@apollo/client";

// Link with the shopify graphql API
const shopifyLink = new HttpLink({
  uri: process.env.NEXT_PUBLIC_API_ENDPOINT,
  headers: {
    "X-Shopify-Storefront-Access-Token": process.env.NEXT_PUBLIC_API_TOKEN,
  },
});
// Link with the graphcms graphql API
const graphcmsLink = new HttpLink({
  uri: process.env.NEXT_PUBLIC_GRAPHCMS_ENDPOINT,
  headers: {
    Authorization: `bearer ${process.env.NEXT_PUBLIC_GRAPHCMS_TOKEN}`,
  },
});

const GRAPHCMS_CLIENT_NAME = "graphcms";
/**
 * Adding this to apollo query options will use the graphcms graphql API
 */
export const useGraphcmsOptions = {
  context: {
    clientName: GRAPHCMS_CLIENT_NAME,
  },
};

export const client = new ApolloClient({
  link: ApolloLink.split(
    operation => operation.getContext().clientName === GRAPHCMS_CLIENT_NAME,
    graphcmsLink,
    shopifyLink
  ),
  cache: new InMemoryCache(),
});
